import React, { useMemo } from "react";
import {
  sortReportBrands,
  ReportFilterSection,
  SelectComponent,
  isGroupAdmin,
} from "../../../../shared";
import {
  REPORT_FILTER_LABELS,
  REPORT_FILTER_CLASSES,
  REPORT_FILTER_OVERLAY_STYLES,
} from "../../../../constants";

import { groupsConstants } from "../../constants";
import { emptyString, storesConstants } from "../../../admin-screens/constants";

const FiltersComponent = (props) => {
  const {
    stores,
    spinner,
    brandId,
    allBrands,
    allGroups,
    dateState,
    setDateState,
    selectedBrand,
    selectedGroup,
    selectedLocation,
    setSelectedGroup,
    setSelectedLocation,
    getStoresAgainstGroupId,
    getStoresAgainstBrandId,
    isTodayExcluded = false,
  } = props;

  const handleGroupChange = (e) => {
    setSelectedGroup(e);
    if (e.id) {
      getStoresAgainstGroupId(e.id);
    } else {
      getStoresAgainstBrandId(brandId);
    }
    setSelectedLocation({
      id: emptyString,
      name: REPORT_FILTER_LABELS.STORE,
    });
  };

  // Derive brand options so cleared lists cannot leave old choices behind.
  const brands = useMemo(() => sortReportBrands(allBrands ?? []), [allBrands]);

  const isBrandsLoading = spinner(storesConstants.FETCH_ALL_BRANDS);
  const isGroupsLoading = spinner(groupsConstants.GROUPS_DATA);
  const isStoresLoading = spinner(storesConstants.FETCH_BRAND_LOCATIONS);

  return (
    <div className="notification-form shadow card my-3">
      <div className="card-body py-4">
        <ReportFilterSection
          dateState={dateState}
          setDateState={setDateState}
          isTodayExcluded={isTodayExcluded}
        >
          <SelectComponent
            value={selectedBrand}
            options={[
              {
                value: emptyString,
                name: REPORT_FILTER_LABELS.BRAND,
                isDisabled: true,
              },
              ...brands,
            ]}
            placeholder={REPORT_FILTER_LABELS.BRAND}
            styles={REPORT_FILTER_OVERLAY_STYLES}
            className={REPORT_FILTER_CLASSES.SPACED_SELECT}
            isLoading={isBrandsLoading}
            isDisabled
          />
          <SelectComponent
            value={[selectedGroup]}
            options={[
              {
                value: emptyString,
                name: REPORT_FILTER_LABELS.GROUP,
              },
              ...allGroups,
            ]}
            onChange={handleGroupChange}
            placeholder={REPORT_FILTER_LABELS.GROUP}
            styles={REPORT_FILTER_OVERLAY_STYLES}
            className={REPORT_FILTER_CLASSES.SPACED_SELECT}
            isLoading={isGroupsLoading}
            isDisabled={isGroupsLoading || isGroupAdmin()}
          />
          <SelectComponent
            value={[selectedLocation]}
            options={[
              {
                value: emptyString,
                name: REPORT_FILTER_LABELS.STORE,
              },
              ...stores,
            ]}
            onChange={(e) => setSelectedLocation(e)}
            placeholder={REPORT_FILTER_LABELS.STORE}
            styles={REPORT_FILTER_OVERLAY_STYLES}
            classNamePrefix="stores-select"
            className={REPORT_FILTER_CLASSES.SELECT}
            isLoading={isStoresLoading}
            isDisabled={isStoresLoading}
          />
        </ReportFilterSection>
      </div>
    </div>
  );
};

export default FiltersComponent;
